/**
 * Storefront chrome.
 *
 * Adds the two pieces of marketplace furniture that Frappe's website layout
 * has no slot for:
 *   1. a search bar sitting inside the navbar, between brand and icons
 *   2. a bottom nav bar on phones
 *
 * Both are built in JS rather than in a template override so we never have to
 * fight Frappe's navbar.html inheritance chain across versions. Everything is
 * additive — delete this file from web.bundle.js and the site still works.
 */

window.webshop = window.webshop || {};

webshop.storefront = {
	SEARCH_ROUTE: "/all-products",

	escape(text) {
		return String(text == null ? "" : text)
			.replace(/&/g, "&amp;")
			.replace(/</g, "&lt;")
			.replace(/>/g, "&gt;")
			.replace(/"/g, "&quot;");
	},

	/* ------------------------------------------------------------------ */

	mount_search() {
		const $navbar = $(".navbar").first();
		if (!$navbar.length || $navbar.find(".sf-search").length) return;

		const term = frappe.utils.get_url_arg("search") || "";
		const $search = $(`
			<div class="sf-search">
				<form action="${ this.SEARCH_ROUTE }" method="get" role="search">
					<label class="sf-visually-hidden" for="sf-search-input">
						${ __("Search products") }
					</label>
					<input type="search" id="sf-search-input" name="search"
						autocomplete="off"
						placeholder="${ __("Search products, brands and categories") }"
						value="${ this.escape(term) }">
					<button type="submit">${ __("Search") }</button>
				</form>
			</div>
		`);

		// Slot it right after the brand so flex ordering does the rest.
		const $brand = $navbar.find(".navbar-brand").first();
		if ($brand.length) {
			$brand.after($search);
		} else {
			$navbar.find(".container").first().prepend($search);
		}
	},

	/* ------------------------------------------------------------------ */

	mount_bottom_nav() {
		if ($(".sf-bottom-nav").length) return;

		const path = window.location.pathname;
		const active = route => (path === route ? "active" : "");

		const icon = d =>
			`<svg viewBox="0 0 24 24" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">${ d }</svg>`;

		const $nav = $(`
			<nav class="sf-bottom-nav" aria-label="${ __("Main") }">
				<a href="/" class="${ active("/") }">
					${ icon('<path d="M3 10l9-7 9 7v10a1 1 0 0 1-1 1h-5v-7H9v7H4a1 1 0 0 1-1-1z"/>') }
					<span>${ __("Home") }</span>
				</a>
				<a href="/all-products" class="${ active("/all-products") }">
					${ icon('<circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/>') }
					<span>${ __("Browse") }</span>
				</a>
				<a href="/wishlist" class="${ active("/wishlist") }">
					${ icon('<path d="M20.8 6.6a5 5 0 0 0-7.1 0L12 8.3l-1.7-1.7a5 5 0 0 0-7.1 7.1L12 21l8.8-7.3a5 5 0 0 0 0-7.1z"/>') }
					<span class="sf-nav-count" data-count="wish"></span>
					<span>${ __("Saved") }</span>
				</a>
				<a href="/cart" class="${ active("/cart") }">
					${ icon('<circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2 3h3l2.6 12h11L21 7H6"/>') }
					<span class="sf-nav-count" data-count="cart"></span>
					<span>${ __("Cart") }</span>
				</a>
			</nav>
		`);

		$("body").append($nav);
		this.sync_counts();
	},

	/* ------------------------------------------------------------------ */

	/**
	 * shopping_cart.js and wishlist.js own the navbar badges. Rather than
	 * duplicate their logic, mirror whatever they render into the bottom nav.
	 */
	sync_counts() {
		$('.sf-nav-count[data-count="cart"]').text($("#cart-count").text() || "");
		$('.sf-nav-count[data-count="wish"]').text($("#wish-count").text() || "");
	},

	watch_counts() {
		const targets = [
			document.getElementById("cart-count"),
			document.getElementById("wish-count"),
		].filter(Boolean);

		if (!targets.length || !window.MutationObserver) return;

		const observer = new MutationObserver(() => this.sync_counts());
		targets.forEach(node =>
			observer.observe(node, { childList: true, characterData: true, subtree: true })
		);
	},

	/* ------------------------------------------------------------------ */

	/**
	 * Live countdown on deal rows. The end time is rendered server-side into
	 * data-ends, so the row itself stays cacheable.
	 */
	start_countdowns() {
		const nodes = document.querySelectorAll(".sf-countdown[data-ends]");
		if (!nodes.length) return;

		const pad = n => String(Math.floor(n)).padStart(2, "0");

		const tick = () => {
			let any_running = false;

			nodes.forEach(node => {
				const ends = new Date(node.dataset.ends.replace(" ", "T")).getTime();
				if (isNaN(ends)) return;

				let left = ends - Date.now();

				if (left <= 0) {
					node.textContent = __("Ended");
					return;
				}

				any_running = true;
				left = left / 1000;

				const parts = [
					pad(left / 3600),
					pad((left % 3600) / 60),
					pad(left % 60),
				];

				node.innerHTML = parts.map(p => `<span>${ p }</span>`).join(":");
			});

			if (any_running) setTimeout(tick, 1000);
		};

		tick();
	},
};

frappe.ready(() => {
	webshop.storefront.mount_bottom_nav();
	webshop.storefront.watch_counts();
	webshop.storefront.start_countdowns();
});
